








































































































































































































































































































































// REVIEW: the overall complexcity of this component is too high and it
// should be broken down into individually smaller pieces.
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import { mixin as clickaway } from "vue-clickaway";
import resize from "vuetify/es5/directives/resize";
import debounce from "lodash.debounce";
import Hammer from "hammerjs";
import Vue from "vue";
import { isMobile } from "@/utils/responsive";
import useMatomoEvent from "@/composition/useMatomoEvent";
import maxZIndex from "@/views/lib/useMaxZIndex";

@Component({
  inject: ["eventBus"],
  mixins: [clickaway],
  directives: { resize },
  setup() {
    const trackOpenAdvancedSearch = () => {
      useMatomoEvent({
        category: "Advanced Search",
        action: 'Click "Erweiterte Suche"',
        name: "Open Advanced Search"
      });
    };

    const trackSearchAdvancedSearch = () => {
      useMatomoEvent({
        category: "Advanced Search",
        action: 'Advanced Search "Erweiterte Suche" Click Search',
        name: "Search Advanced Search"
      });
    };

    const onSearchEnter = debounce(() => {
      useMatomoEvent({
        category: "Search",
        action: "Search Bar Hit Enter",
        name: "Search Bar Enter"
      });
    });

    const trackBreakingNewsClick = () => {
      useMatomoEvent({
        category: "Advanced Search",
        action: 'Click "Eilmeldung"',
        name: "Quick Search Filter Eilmeldung"
      });
    };

    return {
      trackOpenAdvancedSearch,
      trackSearchAdvancedSearch,
      onSearchEnter,
      trackBreakingNewsClick,
      useMatomoEvent,
      maxZIndex
    };
  }
})
export default class CdkSearch extends Vue {
  @Prop({
    type: Object || undefined,
    default: () => undefined
  })
  eventBus: any | undefined;

  @Prop({
    type: Array,
    default: () => []
  })
  filterRules!: any[];

  @Watch("filterRules")
  onFilterRulesChanged() {
    this.setDiffSearch();
    this.setIsSearchOverflown();
  }

  @Prop({
    type: Array,
    required: true
  })
  value!: any[];

  @Prop({
    type: Array,
    required: true
  })
  items!: any[];

  @Prop({
    type: Boolean,
    required: false
  })
  urgencyActive!: boolean;

  @Prop({
    type: Boolean,
    required: true
  })
  saveEnabled!: boolean;

  @Prop({
    type: Boolean,
    required: true
  })
  hasCurrentFilter: boolean;

  @Prop({
    type: String,
    default: "0"
  })
  frcMaxWidth!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  mobileSearch!: boolean;

  @Prop({
    type: Number,
    default: 48
  })
  height!: number;

  @Prop({
    type: Number,
    default: 48
  })
  width!: number;

  @Prop({
    type: String
  })
  appBarColor?: string;

  isFocused = false;

  isFrcOpen: boolean = false;

  windowWidth: number = 0;

  windowHeight: number = 0;

  offset: number = 0;

  outerEl: any = null;

  innerEl: any = null;

  inputHover: boolean = false;

  $vuetify: any;

  get saveButtonText() {
    return this.hasCurrentFilter
      ? this.$t("saveAsCopy")
      : this.$t("saveAsFilter");
  }

  setHover(value) {
    if (!this.isFocused) {
      this.inputHover = value;
    }
  }

  offsetSearch: number = 0;

  searchOuterEl: any = null;

  @Watch("searchOuterEl", { immediate: true })
  onSearchOuterElChanged() {
    if (this.searchOuterEl) {
      setTimeout(() => {
        this.setDiffSearch();
        this.setIsSearchOverflown();
      }, 300);
    } else {
      this.isSearchOverflown = false;
      setTimeout(this.setSearchOuterEl, 300);
    }
  }

  diffSearch: number = 0;

  async setDiffSearch() {
    await this.$nextTick();
    this.diffSearch = this.getDiffSearch();
  }

  wrappedInputs: any[] = [];

  outer: number = 0;

  inner: number = 0;

  async setInnerAndOuter() {
    await this.$nextTick();
    this.outer = this.getOuter();
    this.inner = this.getInner();
    this.offset = this.getOffset();
  }

  getOuter(): number {
    if (this.outerEl) {
      return this.outerEl.offsetHeight;
    }
    return 0;
  }

  getInner(): number {
    if (this.innerEl) {
      return this.innerEl.offsetHeight;
    }
    return 0;
  }

  get saveDialog() {
    return this.$store.state.ui.showFilterDialog;
  }

  get refs() {
    return this.$refs;
  }

  get appendIcon() {
    const combobox = this.refs["frc-combobox"];
    this.isFocused =
      // @ts-ignore
      combobox && (combobox.isFocused || this.saveDialog || this.isFrcOpen);
    if (this.isFrcOpen) return "arrow_drop_up";
    return "arrow_drop_down";
  }

  refByType(type) {
    return this.refs[type];
  }

  updateChips(event) {
    this.$emit("input", event);

    this.closeMobileFrc();
  }

  closeMobileFrc() {
    if (isMobile(this)) {
      this.isFrcOpen = false;
      this.searchOuterEl = null;
      setTimeout(() => {
        this.eventBus.$emit("close-mobile-frc");
      }, 300);
    }
  }

  get chipColor(): string {
    return this.urgencyActive ? "grey" : "red";
  }

  createFilter(payload): void {
    this.$emit("createFilter", payload);
  }

  removeFilterRuleByIndex(index): void {
    this.$emit("removeFilterRule", index);
  }

  clickawayBlur(): void {
    if (!this.saveDialog) {
      this.isFrcOpen = false;
      this.isFocused = false;
      this.inputHover = false;
    }
  }

  toggleComboboxMenu(): void {
    this.isFrcOpen = !this.isFrcOpen;
  }

  @Watch("isFrcOpen")
  onComboboxMenuChange(): void {
    const combobox = this.$refs["frc-combobox"];
    if (this.isFrcOpen && combobox) {
      // @ts-ignore
      combobox.activateMenu();
      // @ts-ignore
      combobox.$refs.input.focus();
    } else if (!this.mobileSearch) {
      // @ts-ignore EC-603 do not blur the combobox on mobile/tablet
      combobox.blur();
    }
    this.eventBus.$emit("frc-toggled", this.isFrcOpen);
    this.updateComposerInUrl();
  }

  // Mirrors the changes to the FRC open/closed state in the URL.
  updateComposerInUrl(): void {
    const isQueryPresent = this.composerQuery === "open";
    // If the FRC is open and the 'composer: open' query is missing...
    if (this.isFrcOpen && !isQueryPresent) {
      // adds 'composer: open' to the current query without mutating
      this.$router.replace({
        query: { ...this.$route.query, composer: "open" }
      });
      // If the FRC is closed and the 'component: open' query is present...
    } else if (!this.isFrcOpen && isQueryPresent && !isMobile(this)) {
      const query = { ...this.$route.query };
      delete query.composer;
      // replaces the query object by a version without 'composer: open'
      this.$router.replace({ query });
    }
  }

  get composerQuery() {
    return this.$route.query.composer;
  }

  @Watch("composerQuery", { immediate: true })
  onComposerQueryChanged() {
    // If the 'composer: open' query was added but the FRC isn't open...
    if (this.composerQuery === "open" && !this.isFrcOpen && !isMobile(this)) {
      // ...open it, but preventing race condition errors.
      setTimeout(() => {
        this.isFrcOpen = true;
      }, 500);
    }
  }

  focusInput(): void {
    const combobox = this.$refs["frc-combobox"];

    if (combobox) {
      // @ts-ignore
      combobox.activateMenu();
    }

    this.isFocused = true;

    // EC-603 prevent virtual keyboard from toggling on mobile/tablet
    if (!this.saveDialog && combobox) {
      // @ts-ignore
      combobox.$refs.input.focus();
    }
  }

  // EC-603 An array of v-checkbox refs from the FRC
  get checkboxRefs(): any[] {
    const refKeys = Object.keys(this.refs);
    const checkboxKeys = refKeys.filter(key => !!key.match(/cb-.*/));
    const checkboxRefs = checkboxKeys.map(key => this.refs[key]);
    return checkboxRefs;
  }

  // EC-603 returns an array of v-checkbox elements which are flex-wrapped
  getWrappedInputs(): Element[] {
    const wrappedCheckboxEls = this.checkboxRefs.filter(
      ref => ref[0] && ref[0].$el.classList.contains("is-wrapped")
    );
    return wrappedCheckboxEls.map(ref => ref[0].$el);
  }

  // EC-603 An array of flex row elements containing wrapped children
  get wrappedRows(): Element[] {
    const parents = this.wrappedInputs.map(el => el.parentNode);
    const reduced = parents.reduce((acc, el) => {
      if (!acc.find(e => e.outerHTML === el.outerHTML)) {
        return [...acc, el];
      }
      return acc;
    }, []);
    return reduced;
  }

  mounted(): void {
    const combobox = this.refs["frc-combobox"] as Vue;

    const input = combobox.$el.querySelector("input");
    input.addEventListener("keydown", ({ key }) => {
      if (key === "Enter") {
        // @ts-ignore
        this.onSearchEnter();
      }
    });

    // @ts-ignore
    this.isFocused = combobox && combobox.isFocused;
    this.eventBus.$on("frc-close", () => {
      this.isFrcOpen = false;
      this.searchOuterEl = null;
      this.clickawayBlur();
    });

    // EC-603: FRC should always be open when mobile search is active
    if (this.mobileSearch) {
      this.isFrcOpen = true;
    }

    this.setFRCContainers();
    this.eventBus.$on("contextual-navigation", this.focusInput);
  }

  async onResize() {
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;

    await this.$nextTick();
    this.setSearchOuterEl();
    this.setInnerAndOuter();
    this.setDiffSearch();
    this.setIsSearchOverflown();
  }

  /*
   * Returns the maximun height for the menu. Can't use the same patterns as
   * in agenda, because of changed DOM structure. Using default approach by vuetify,
   * which is scrolling the whole container. Therefore the submit button is hidden
   * initially on overflow and the user has to scroll.
   */
  get menuMaxHeight(): number {
    // EC-603: Shorter app bar height and FRC should fill vertical height in mobile view
    const OFFSET_TOP = this.mobileSearch ? 48 : 56;
    const OFFSET_BOTTOM = this.mobileSearch ? 0 : 4;

    return this.windowHeight - OFFSET_TOP - OFFSET_BOTTOM;
  }

  // EC-603 returns the difference in top positions of outerEl and innerEl
  getOffset(): number {
    if (this.innerEl && this.outerEl) {
      const topOuter = this.outerEl.getBoundingClientRect().top;
      const topInner = this.innerEl.getBoundingClientRect().top;
      return topOuter - topInner;
    }
    return 0;
  }

  getOffsetSearch(): number {
    if (this.searchOuterEl) {
      return this.searchOuterEl.scrollLeft;
    }
    return 0;
  }

  get isOverflown(): boolean {
    return this.inner > this.outer;
  }

  isSearchOverflown: boolean = false;

  getIsSearchOverflown(): boolean {
    if (this.searchOuterEl) {
      const clientWidth = this.searchOuterEl.getBoundingClientRect().width;
      const { scrollWidth } = this.searchOuterEl;
      return scrollWidth > clientWidth;
    }
    return false;
  }

  async setIsSearchOverflown() {
    await this.$nextTick();
    this.isSearchOverflown = this.getIsSearchOverflown();
  }

  activateFrcGradient() {
    if (this.mobileSearch) {
      this.eventBus.$emit("activateFrcGradient", {
        isTop: this.isTop,
        isBottom: this.isBottom
      });
    }
  }

  // EC-603 removes gradients
  deactivateFrcGradient() {
    this.eventBus.$emit("activateFrcGradient", {
      isTop: false,
      isBottom: false
    });
  }

  // EC-603 if the FRC is not displayed, remove gradients
  beforeDestroy() {
    this.deactivateFrcGradient();
  }

  // EC-603 whether gradient is shown at the bottom of the FRC
  get isBottom(): boolean {
    return this.diff !== this.offset && this.isOverflown;
  }

  @Watch("isBottom")
  onIsBottomChanged() {
    this.activateFrcGradient();
  }

  // EC-603 whether gradient is shown at the top of the FRC
  get isTop(): boolean {
    return this.offset !== 0 && this.isOverflown;
  }

  @Watch("isTop")
  onIsTopChanged() {
    this.activateFrcGradient();
  }

  get searchGradientIsLeft(): boolean {
    return this.isSearchOverflown && this.offsetSearch !== 0;
  }

  get searchGradientIsRight(): boolean {
    return this.isSearchOverflown && this.offsetSearch !== this.diffSearch;
  }

  get diff(): number {
    return this.inner - this.outer;
  }

  getDiffSearch(): number {
    if (this.searchOuterEl) {
      const clientWidth = this.searchOuterEl.getBoundingClientRect().width;
      const { scrollWidth } = this.searchOuterEl;
      return Math.round(scrollWidth - clientWidth);
    }
    return 0;
  }

  // EC-603 determine if FRC is open and rendered in DOM
  get frcIsRendered(): boolean {
    if (this.outerEl && this.innerEl) {
      const heightOuter = this.outerEl.getBoundingClientRect().height;
      const heightInner = this.innerEl.getBoundingClientRect().height;
      return !!heightOuter && !!heightInner;
    }
    return false;
  }

  @Watch("frcIsRendered")
  onFrcIsRenderedChanged() {
    if (this.frcIsRendered) {
      // EC-603 initialise offsets
      this.offset = this.getOffset();
      this.offsetSearch = this.getOffsetSearch();
      this.setSearchInitial();
      this.setIsSearchOverflown();

      const moveCallback = () => {
        this.offset = this.getOffset();
      };

      // EC-603 track offset position when scrolling or panned vertically
      this.outerEl.addEventListener("touchmove", moveCallback);
      this.outerEl.addEventListener("scroll", moveCallback);
    }
  }

  // EC-603 enable horizontal panning of search bar with Hammerjs
  searchInitial: number = 0;

  async setSearchInitial() {
    await this.$nextTick();
    if (this.searchOuterEl) {
      this.searchInitial = this.searchOuterEl.scrollLeft;
    }
  }

  onSearchPan() {
    const searchHammer = Hammer(this.searchOuterEl);
    searchHammer.get("pan").set({ direction: Hammer.DIRECTION_ALL });

    searchHammer.on("panstart", () => {
      this.setSearchInitial();
    });
    const debouncedPan = debounce(({ deltaX }) => {
      this.searchOuterEl.scrollTo({
        left: this.searchInitial - deltaX,
        top: 0
      });
      this.offsetSearch = this.getOffsetSearch();
    });
    searchHammer.on("pan", debouncedPan);
  }

  // EC-603 initialise pan behaviour when search component has been rendered
  @Watch("searchOuterEl")
  onSearchOuterChanged() {
    if (this.searchOuterEl) {
      this.onSearchPan();
    }
  }

  isCloaked: boolean = true;

  uncloak() {
    this.isCloaked = false;
  }

  // EC-603 query for FRC v-menu (outerEl) and container v-list (inner)
  async setFRCContainers() {
    await this.$nextTick();
    setTimeout(async () => {
      if (this.mobileSearch) {
        const outer: any = document.querySelector(".CdkSearch-combobox");
        const inner: any = outer.querySelector(".v-select-list");
        this.outerEl = outer;
        this.innerEl = inner;
        await this.$nextTick();
        this.setInnerAndOuter();
        this.wrappedInputs = this.getWrappedInputs();
      }

      this.setSearchOuterEl();
      this.uncloak();
    }, 100);
  }

  async setSearchOuterEl() {
    await this.$nextTick();
    // Vuetify input slot with hidden overflow
    const searchOuter: any = document.querySelector(
      `.CdkSearch-input > .v-input__control > .v-input__slot ${
        !this.mobileSearch ? "> .v-select__slot > .v-select__selections" : ""
      }`
    );
    this.searchOuterEl = searchOuter;
  }

  getFrcGradientBackground(direction, inner = false) {
    const transparent = "rgba(255, 255, 255, 0)";
    const darken = `rgba(0, 0, 0, ${this.inputHover ? "0.12" : "0.06"})`;
    let fromColor = transparent;
    let toColor = this.isFocused || this.isFrcOpen ? "#fff" : this.appBarColor;
    if (inner && !(this.isFocused || this.isFrcOpen)) {
      fromColor = transparent;
      toColor = darken;
    }

    return {
      backgroundImage: `linear-gradient(to ${direction}, ${fromColor}, ${toColor})`
    };
  }

  // REVIEW: EC-603 the implementation of wrapped checkbox rows should be refactored *too complex*

  // EC-603 check if flexbox container is wrapped based on clientRect.bottom
  // of the container compared against the first child node
  isInputRowWrapped(parent): boolean {
    const parentEl = this.$refs[parent];

    // @ts-ignore
    if (parentEl.childNodes.length) {
      // @ts-ignore
      const firstChild = parentEl.childNodes[0];
      const firstChildBottom = firstChild.getBoundingClientRect().bottom;
      // @ts-ignore
      const parentElBottom = parentEl.getBoundingClientRect().bottom;
      return firstChildBottom !== parentElBottom;
    }
    return false;
  }

  // EC-603 check if an element (ref) is flexbox wrapped based on its parent
  isInputWrapped({ ref, parent }): boolean {
    // @ts-ignore
    const refEl = this.$refs[ref];
    if (refEl) {
      const parentEl = this.$refs[parent];

      if (this.isInputRowWrapped(parent)) {
        // @ts-ignore
        const refElBottom = refEl[0].$el.getBoundingClientRect().bottom;
        // @ts-ignore
        const firstChild = parentEl.childNodes[0];
        const firstChildBottom = firstChild.getBoundingClientRect().bottom;
        // @ts-ignore
        return refElBottom !== firstChildBottom;
      }
    }
    return false;
  }
}
